import React, { Component } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import { ActionCreators } from "../../actions";

class OCRegister extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {
        email: "",
        password: "",
        firstName: "",
        lastName: ""
      },
      errors: []
    };
  }

  login(e) {
    this.props.push("/oc/login");
  }

  register() {
    let error = [];

    Object.keys(this.state.user).forEach((k, i) => {
      if (!this.state.user[k] || this.state.user[k] === "")
        error.push({ field: k, error: "required" });
    });

    this.setState(prevState => ({
      ...prevState,
      errors: error
    }));

    if (error.length === 0) {
      this.props
        .registerAction(this.state.user)
        .then(() => {
          this.login();
          this.props.openModal(
            "success",
            "Registration Success",
            "You have registered successfully."
          );
        })
        .catch(error => {
          this.props.openModal(
            "error",
            "Bad Request",
            "Oops something went wrong :( try again later"
          );
        });
    }
  }

  render() {
    return (
      <div className="card">
        <div className="card-body">
          <div className="card-title text-center">
            <img
              src="/images/devstack_logo.png"
              className="img-fluid"
              alt="DevStack"
            />
          </div>
          <h5 className="card-subtitle text-center mb-5 text-muted">
            DevStack Recruitment Backoffice
          </h5>
          <div className="row">
            <div className="col">
              <div className="form-field">
                <label>Email</label>
                <input
                  autoFocus={true}
                  type="email"
                  value={this.state.user.email}
                  onChange={event => {
                    this.setState({
                      ...this.state,
                      user: {
                        ...this.state.user,
                        email: event.target.value
                      }
                    });
                  }}
                />
                {this.state.errors.map(x => x.field).indexOf("email") > -1 && (
                  <span className="fieldErrorText">
                    {this.state.errors.find(x => x.field === "email").error}
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <div className="form-field">
                <label>First Name</label>
                <input
                  type="text"
                  value={this.state.user.firstName}
                  onChange={event => {
                    this.setState({
                      ...this.state,
                      user: {
                        ...this.state.user,
                        firstName: event.target.value
                      }
                    });
                  }}
                />
                {this.state.errors.map(x => x.field).indexOf("firstName") >
                  -1 && (
                  <span className="fieldErrorText">
                    {this.state.errors.find(x => x.field === "firstName").error}
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <div className="form-field">
                <label>Last Name</label>
                <input
                  type="text"
                  value={this.state.user.lastName}
                  onChange={event => {
                    this.setState({
                      ...this.state,
                      user: {
                        ...this.state.user,
                        lastName: event.target.value
                      }
                    });
                  }}
                />
                {this.state.errors.map(x => x.field).indexOf("lastName") >
                  -1 && (
                  <span className="fieldErrorText">
                    {this.state.errors.find(x => x.field === "lastName").error}
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <div className="form-field">
                <label>Password</label>
                <input
                  type="password"
                  value={this.state.user.password}
                  onChange={event => {
                    this.setState({
                      ...this.state,
                      user: {
                        ...this.state.user,
                        password: event.target.value
                      }
                    });
                  }}
                />
                {this.state.errors.map(x => x.field).indexOf("password") >
                  -1 && (
                  <span className="fieldErrorText">
                    {this.state.errors.find(x => x.field === "password").error}
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <button
                onClick={() => {
                  this.register();
                }}
                className="gs-btn gs-btn-blue mt-5"
              >
                Register
              </button>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <button
                onClick={() => {
                  this.login();
                }}
                className="gs-btn gs-btn-grey mt-3"
              >
                Login
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    loggedinUser: state.loggedinUser,
    isLoggedin: state.isLoggedin
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OCRegister)
);



// WEBPACK FOOTER //
// ./src/pages/unauth/ocRegister.js